module.exports = __webpack_public_path__ + "img/device-lock.82b95cee.svg";